import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { history } from 'index'
import { Helmet } from 'react-helmet'
import { notification } from 'antd'
import SignUp from 'gl-react-components/src/components/commonui/SignUp/SignUp'
import Footer from 'components/customComponents/Footer'
// import Spacer from 'components/customComponents/Spacer'

const mapStateToProps = ({ user, dispatch, register }) => ({
  user,
  dispatch,
  email: user.email,
  isUserRegistered: user.isUserRegistered,
  loading: user.loading,
  initialFormValues: register.signupFormData,
})

const SystemRegister = ({ dispatch, loading, email, isUserRegistered, initialFormValues }) => {
  const [isNewUserRegistered] = useState(isUserRegistered)
  const [btnLabel] = useState('REGISTER')
  // const [formTitle, setFormTitle] = useState('Get started')
  const [formView] = useState(true)
  const [viewLoginLink, setViewLoginLink] = useState(true)
  // const [viewDescriptionCard, setViewDescriptionCard] = useState(false)
  const [isTermsConditionsAccpted, setIsTermsConditionsAccpted] = useState(false)
  const [isUserNeedEmailUpdates, setIsUserNeedEmailUpdates] = useState(false)
  const [isUserEnable2FA, setIsUserEnable2FA] = useState(false)
  // const [isFirstRendering] = useState(locationChange)
  // const [isFirstRender] = useState(locationChange);

  useEffect(() => {
    dispatch({
      type: 'UPDATE_PREVIOUS_LOCATION',
      url: '/auth/register',
    })
    if (isUserRegistered !== isNewUserRegistered) {
      setViewLoginLink(false)
      // setFormTitle('You have mail')
      // setBtnLabel('SEND ANOTHER LINK')
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }, [dispatch, isNewUserRegistered, isUserRegistered])

  const onSubmitFinish = values => {
    if (btnLabel === 'REGISTER' && Object.entries(values).length > 0 && isTermsConditionsAccpted) {
      values.tAndCsAccepted = isTermsConditionsAccpted
      values.emailSubscription = isUserNeedEmailUpdates
      values.use_mfa = isUserEnable2FA
      values.portal = 'cms'
      dispatch({
        type: 'REGISTER',
        payload: values,
      })
    }
    if (!isTermsConditionsAccpted) {
      notification.warning({
        message: 'Warning',
        description: 'Please accept the terms to continue the registration.',
      })
    }
  }

  const onFieldsChange = (data, item) => {
    setTimeout(() => {
      dispatch({
        type: 'UPDATE_USER_INPUT_DATA_REGISTER',
        payload: item,
      })
    }, 500)
  }

  // const onInputEmpty = () => {
  //   return dispatch({
  //     type: 'UPDATE_USER_INPUT_DATA',
  //     payload: initialFormValues,
  //   })
  // }

  const handleLinksDescription = label => {
    if (label === 'login') {
      history.push('/auth/login')
    }
    if (label === 'privacy-policy') {
      history.push('/auth/privacy-policy')
    }
    if (label === 'terms-services') {
      history.push('/auth/terms-of-services')
    }
    if (label === 'terms-to-use') {
      history.push('/auth/terms-of-services')
    }
    if (label === 'submit') {
      dispatch({
        type: 'SEND_EMAIL_CONFIRM_LINK',
        payload: email,
      })
    }
  }

  // const handleClose = () => {
  //   setViewDescriptionCard(false)
  // }

  const onChangeIsUserEnable2FA = e => {
    setIsUserEnable2FA(e.target.checked)
  }

  const onChangeIsTermsConditionsAccpted = e => {
    setIsTermsConditionsAccpted(e.target.checked)
  }

  const onChangeIsUserNeedEmailUpdates = e => {
    setIsUserNeedEmailUpdates(e.target.checked)
  }

  const handleRedirectLogin = () => {
    history.push('/auth/login')
  }

  // const getCardContent = () => {
  //   return (
  //     <div>
  //       <div>
  //         Please go to your inbox to confirm your mail address, then follow the link back here.
  //       </div>
  //       <Spacer height="15px" />
  //       <div>
  //         No email? Check junk mail. Failing that, <br /> let us send you another link...{' '}
  //       </div>
  //     </div>
  //   )
  // }

  // const getPolicesPagesOnSelection = label => {
  //   let returnResp
  //   switch (label) {
  //     case 'terms-to-use':
  //       returnResp = <TermsToUse />
  //       break
  //     case 'privacy-policy':
  //       window.scrollTo({ top: 0, behavior: 'smooth' })
  //       returnResp = <PrivacyPolicy />
  //       break
  //     case 'terms-services':
  //       window.scrollTo({ top: 0, behavior: 'smooth' })
  //       returnResp = <TermsOfServices />
  //       break
  //     default:
  //       break
  //   }
  //   return returnResp
  // }

  return (
    <div>
      <Helmet title="Register" />
      <SignUp
        label={btnLabel}
        formTitle={<div style={{ marginTop: '-30px' }}>Get started</div>}
        bannerText={
          <div>
            The architects of currency <br /> and liqudity management
          </div>
        }
        bannerTitle={
          <div>
            we make it simple for global business to trade, <br /> transfer and store traditional
            and crypto currencies
          </div>
        }
        copyRights="@2020 Pay Perform Limited."
        formData={[
          {
            label: 'First Name',
            fieldName: 'firstName',
            inputType: 'input',
            required: true,
          },
          {
            label: 'Last Name',
            fieldName: 'lastName',
            inputType: 'input',
            required: true,
          },
          {
            label: 'Email',
            fieldName: 'email',
            inputType: 'input',
            required: true,
          },
          {
            label: 'Password',
            fieldName: 'password',
            inputType: 'input',
            placholder: 'Must be at least 8 characters',
            required: true,
          },
          // {
          //   label: 'Phone Number',
          //   fieldName: 'mobilePhone',
          //   inputType: 'input',
          //   required: true,
          // },
        ]}
        signUp
        loading={loading}
        mainLoader={false}
        enableLoginLink={viewLoginLink}
        stepStatus={['']}
        progressLog={false}
        viewForm={formView}
        // viewDescription={viewDescriptionCard}
        // cardMessage={!formView && getCardContent()}
        // cardDescription={getPolicesPagesOnSelection(policesDesciptionName)}
        onChangeTermsConditions={onChangeIsTermsConditionsAccpted}
        onChangeEmailUpdates={onChangeIsUserNeedEmailUpdates}
        onChangeEnable2fa={onChangeIsUserEnable2FA}
        // handleCloseDescription={() => handleClose()}
        handleRedirectLogin={handleRedirectLogin}
        backgroundHeight="500px"
        // footerHeight={btnLabel !== 'REGISTER' && '200px'}
        handleClickFun={value => handleLinksDescription(value)}
        // handlePrivacyPolicy={handlePrivacyPolicy}
        // handleTermsAndServices={handleTermsAndServices}
        initialFormValues={initialFormValues}
        onFieldsChange={onFieldsChange}
        onSubmitForm={onSubmitFinish}
      />
      <Footer />
    </div>
  )
}

export default withRouter(connect(mapStateToProps)(SystemRegister))
